export const API_URL = process.env.REACT_APP_API_URL

export const MIN_RETRIEVED_CANDIDATES = process.env.REACT_APP_MIN_RETRIEVED_CANDIDATES

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT

export const HIGH_REQ_THRESHOLD = process.env.REACT_APP_HIGH_REQ_THRESHOLD;

export const LOW_REQ_THRESHOLD = process.env.REACT_APP_LOW_REQ_THRESHOLD;

export const NUMBER_OF_VACANCIES_PER_PAGE = process.env.REACT_APP_NUMBER_OF_VACANCIES_PER_PAGE;

export const IS_TALENT_POOL_ENABLED = process.env.REACT_APP_IS_TALENT_POOL_ENABLED;

export const IS_PROFESSIONAL_NETWORK_DISABLED = true;

export const ONBOARDING_TRANSFER_FEE_MAX = process.env.REACT_APP_ONBOARDING_TRANSFER_FEE_MAX;

export const ONBOARDING_TRANSFER_FEE_MIN = process.env.REACT_APP_ONBOARDING_TRANSFER_FEE_MIN;

export const ONBOARDING_TRANSFER_FEE_STEP = process.env.REACT_APP_ONBOARDING_TRANSFER_FEE_STEP;

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const COMPLETE_MVP_PROFILE_EXPERIENCE_VALUE = process.env.REACT_APP_COMPLETE_MVP_PROFILE_EXPERIENCE_VALUE;

export const IS_CHANCE_OF_HIGH_FIVE_COUNT_ENABLED = process.env.REACT_APP_IS_CHANCE_OF_HIGH_FIVE_COUNT_ENABLED;

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID

export const WHATSAPP_APP_ID = process.env.REACT_APP_WHATSAPP_APP_ID;

export const WHATSAPP_ES_CONFIG_ID = process.env.REACT_APP_WHATSAPP_ES_CONFIG_ID;

export const IS_WHATSAPP_CONFIG_ENABLED = process.env.REACT_APP_IS_WHATSAPP_CONFIG_ENABLED === "true";

export const GOOGLE_TAG_MANAGER_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

export const PROFESSIONAL_ONBOARDING_ENABLE_AI_VOICE = process.env.REACT_APP_PROFESSIONAL_ONBOARDING_ENABLE_AI_VOICE;

export const PROFESSIONAL_ONBOARDING_ENABLE_AI_AVATAR = process.env.REACT_APP_PROFESSIONAL_ONBOARDING_ENABLE_AI_AVATAR;

export const COMPANY_UNVERIFIED_LOGIN_LIMIT = process.env.REACT_APP_COMPANY_UNVERIFIED_LOGIN_LIMIT;

export const PROFESSIONAL_UNVERIFIED_LOGIN_LIMIT= process.env.REACT_APP_PROFESSIONAL_UNVERIFIED_LOGIN_LIMIT;

export const PROFESSIONAL_NOTIFICATION_WHATSAPP_OPTIN_LIMIT = process.env.REACT_APP_PROFESSIONAL_NOTIFICATION_WHATSAPP_OPTIN_LIMIT;

export const PROFESSIONAL_PROFILE_INTERVIEW_ENABLE_AI_VOICE = process.env.REACT_APP_PROFESSIONAL_PROFILE_INTERVIEW_ENABLE_AI_VOICE;

export const PROFESSIONAL_PROFILE_INTERVIEW_ENABLE_AI_AVATAR = process.env.REACT_APP_PROFESSIONAL_PROFILE_INTERVIEW_ENABLE_AI_AVATAR;

export const PROFESSIONAL_JOB_MATCH_INTERVIEW_ENABLE_AI_VOICE = process.env.REACT_APP_PROFESSIONAL_JOB_MATCH_INTERVIEW_ENABLE_AI_VOICE;

export const PROFESSIONAL_JOB_MATCH_INTERVIEW_ENABLE_AI_AVATAR = process.env.REACT_APP_PROFESSIONAL_JOB_MATCH_INTERVIEW_ENABLE_AI_AVATAR;

export const RENDER_INTERVIEW_PAGE = process.env.REACT_APP_RENDER_INTERVIEW_PAGE;

export const INTERVIEW_TIMEOUT_MINUTES = process.env.REACT_APP_INTERVIEW_TIMEOUT_MINUTES;

export const IS_TAVUS_INITIAL_PROVIDER = process.env.REACT_APP_IS_TAVUS_INITIAL_PROVIDER;